import styled from "@emotion/styled";
import { Container } from "@mui/material";

const HeaderContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 0px);
  padding: 20px 0px;
  @media screen and (max-width:899px){
    
    /* min-height: calc(100vh - 110px); */
  }
  @media screen and (max-width:599px){
    
    /* min-height: calc(100vh - 0px); */
  }
`;

export { HeaderContainer };
